import React from 'react';
import { connect } from 'react-redux';

import { API_ROOT } from '../../../constants';
import { HTTP_METHOD_GET } from '../../../constants/httpMethod';
import { MODAL_TYPE_LOGGED_OUT } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';
import { logoutUser } from '../../../services/authentication/logout/actions';

import { isTokenExpired } from '../../../services/authentication/utils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import AloWidgetComponent from '../../alo/AloWidgetComponent';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './AloPage.scss';

export class AloPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            widgetUrl: '',
            termsAccepted: true
        };
    }

    componentWillMount() {
        this.checkAuthentication(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isAuthenticated !== this.props.isAuthenticated) {
            this.checkAuthentication(nextProps);
        }
    }

    componentDidMount() {
        this.getOxlinWidgetUrl(this.props.token);
    }

    isMemberAuthenticated = (token, isAuthenticated) =>
        token && !isTokenExpired(token) && isAuthenticated;

    checkAuthentication({ history, showModal, logoutUser, isAuthenticated, token }) {
        if (!this.isMemberAuthenticated(token, isAuthenticated)) {
            new Promise((resolve, reject) => {
                history.push('/');
                resolve();
            }).then(() => logoutUser(() => showModal(MODAL_TYPE_LOGGED_OUT)));
        }
    }

    getOxlinWidgetUrl = token => {
        let config = {
            credentials: 'same-origin',
            method: HTTP_METHOD_GET,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        };

        fetch(`${API_ROOT}/account-linked-offer/widget`, config)
            .then(response => response.json())
            .then(data => {
                if (!data.termsAccepted) {
                    window.location.href = data.widgetUrl;
                }
                this.setState({ widgetUrl: data.widgetUrl, termsAccepted: data.termsAccepted });
            });
    };

    render() {
        const { i18n } = this.props;
        const { widgetUrl, termsAccepted } = this.state;

        return (
            <main role="main" className="conteneur conteneur-mobile" id="p-alo">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />

                {widgetUrl ? (
                    termsAccepted && <AloWidgetComponent widgetUrl={this.state.widgetUrl} />
                ) : (
                    <LoadingComponent />
                )}
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ALO,
        isAuthenticated: state.authentication.isAuthenticated,
        token: state.authentication.token
    };
};

const mapDispatchToProps = {
    showModal,
    logoutUser
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(AloPage),
    PrimaryTemplate,
    {
        hideBreadcrumb: true,
        hideNav: true,
        hideSearch: true
    }
);



// WEBPACK FOOTER //
// ./src/components/pages/alo/AloPage.js